import { Component, OnInit, signal, Type, inject } from '@angular/core';
import { StateService, Transition } from '@uirouter/angular';

import CONSTANTS from '@constants';
import { BackgroundBrandedService } from '@app/shared/modules/background-branded/services/background-branded.service';
import { CompanyService } from '@app/shared/services/company.service';

import { TranslateService } from '@app/shared/modules/translate/services/translate.service';
import { IFBCompany } from '@interfaces';

import { IcAolComponent } from '@app/shared/modules/icons/components/ic/ic-aol-standalone.component';
import { IcGmailComponent } from '@app/shared/modules/icons/components/ic/ic-gmail-standalone.component';
import { IcGmxComponent } from '@app/shared/modules/icons/components/ic/ic-gmx-standalone.component';
import { IcIcloudComponent } from '@app/shared/modules/icons/components/ic/ic-icloud-standalone.component';
import { IcOutlookComponent } from '@app/shared/modules/icons/components/ic/ic-outlook-standalone.component';
import { IcYahooComponent } from '@app/shared/modules/icons/components/ic/ic-yahoo-standalone.component';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-register-email-sent',
  templateUrl: './register-email-sent.component.html',
  styleUrl: '../register.component.scss',
  standalone: false
})
export class RegisterEmailSentComponent implements OnInit {
  private backgroundBrandedService = inject(BackgroundBrandedService);
  private companyService = inject(CompanyService);
  private transition = inject(Transition);
  private translateService = inject(TranslateService);
  private stateService = inject(StateService);

  company = signal<IFBCompany>(this.companyService.data);
  email = signal('');
  emailVendor = signal<{ url: string; id: string; iconComponent: Type<any> }>(null);
  supportLink = signal(this.translateService.getLocalizedConstantString(CONSTANTS.WEB_LINKS.SUPPORT));

  ngOnInit() {
    this.email.set(this.transition.params().email);
    if (!this.email()) {
      this.stateService.go('register');
    }
    this.setEmailVendor();
    this.backgroundBrandedService.fetchBranding().pipe(first()).subscribe();
  }

  private setEmailVendor() {
    const emailVendors = {
      google: { url: 'https://mail.google.com', id: 'gmail', iconComponent: IcGmailComponent },
      yahoo: { url: 'https://mail.yahoo.com', id: 'yahoo', iconComponent: IcYahooComponent },
      outlook: { url: 'https://outlook.live.com', id: 'outlook', iconComponent: IcOutlookComponent },
      icloud: { url: 'https://www.icloud.com/mail', id: 'icloud', iconComponent: IcIcloudComponent },
      aol: { url: 'https://mail.aol.com', id: 'aol', iconComponent: IcAolComponent },
      gmx: { url: 'https://www.gmx.com', id: 'gmx', iconComponent: IcGmxComponent }
    };

    const emailDomains = {
      gmail: emailVendors.google,
      googlemail: emailVendors.google,
      yahoo: emailVendors.yahoo,
      ymail: emailVendors.yahoo,
      outlook: emailVendors.outlook,
      hotmail: emailVendors.outlook,
      live: emailVendors.outlook,
      msn: emailVendors.outlook,
      icloud: emailVendors.icloud,
      me: emailVendors.icloud,
      mac: emailVendors.icloud,
      aol: emailVendors.aol,
      gmx: emailVendors.gmx
    };

    const domain = this.extractBaseDomain(this.email());
    this.emailVendor.set(emailDomains[domain]);
  }

  private extractBaseDomain(email: string) {
    if (!email) {
      return;
    }
    const domain = email.split('@')[1];
    const domainPart = domain.split('.')[0];
    return domainPart;
  }
}
